import React from 'react'
import { InputNumber } from 'antd';
import { Input } from 'antd';
import { Table } from 'antd';
const { Search } = Input;

const CommonTable = ({columns,data,expandable}) => {
    const onChange = (value) => {
        console.log('changed', value);
      };
  return (
    <div className='table_div'>

       <div className='table_top'>
          <div>
             Show <InputNumber min={1} max={10} defaultValue={3} onChange={onChange} /> entries
          </div>
          <div className='table_search'>
             <p>Search:</p><Input  />
          </div>
       </div>


       <div className='table_div'>
        <Table
          columns={columns}
          expandable={
            expandable && {
              expandedRowRender: (record) => (
                <p
                  style={{
                    margin: 0,
                  }}
                >
                  {record.description}
                </p>
              ),
              rowExpandable: (record) => record.name !== 'Not Expandable',
            }
          }
          dataSource={data}
        />
      </div>

    </div>
  )
}

export default CommonTable
